import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Link } from "../../../library-js/dom-tools/LinkResolver";
import { Message } from "../../../library-js/messages/Message";
import { Request } from "../../../library/ts/html/server/Request";
import { Rokojori } from "../../js/Rokojori";

export class StorageInput
{
  id:string;
  key:string;
  path:string;
  data:any;
  requestID:string;
}

export class StorageResult
{
  requestID:string;
  error:boolean;
  messages:Message[];
  value:any;
}

export class StorageTest
{
  static readonly type = new ElementType( "storage-test" );

  static readonly setAttribute = new ElementAttribute( "storage-set" );
  static readonly getAttribute = new ElementAttribute( "storage-get" );
  static readonly listAttribute = new ElementAttribute( "storage-list" );
  static readonly removeAttribute = new ElementAttribute( "storage-remove" );

  static readonly id   = new AttributeValue( ElementAttribute.dataName, "ID" );
  static readonly key  = new AttributeValue( ElementAttribute.dataName, "Key" );
  static readonly path = new AttributeValue( ElementAttribute.dataName, "Path" );
  static readonly data = new AttributeValue( ElementAttribute.dataName, "Data" );
  
  static applyOnDocument()
  {
    StorageTest.type.forAllInDoc( e => StorageTest.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let storageRootLink = Link.Root( "_php/storage/" );
    let storageURL = Rokojori.$.pageHandler.createAbsoluteLink( storageRootLink );

    let setElement = StorageTest.setAttribute.query<HTMLElement>( e );
    let getElement = StorageTest.getAttribute.query<HTMLElement>( e );
    let listElement = StorageTest.listAttribute.query<HTMLElement>( e );
    let removeElement = StorageTest.removeAttribute.query<HTMLElement>( e );

    OnClick.add( setElement, 
      async ( ev )=>
      {
        let input = new StorageInput();
        input.id = ElementType.input.query( StorageTest.id.query( e ) ).value;
        input.key = ElementType.input.query( StorageTest.key.query( e ) ).value;
        input.path = ElementType.input.query( StorageTest.path.query( e ) ).value;
        input.requestID = new Date().getTime() + "";

        let dataValue = StorageTest.data.query<HTMLTextAreaElement>( e ).value;
        input.data = JSON.parse( dataValue );

        let setPath = storageURL.path + "set.php";
        console.log( "Set", setPath, input );
        let result = await Request.post( setPath, input );

        console.log( "Result", result );

      }
    );

    OnClick.add( getElement, 
      async ( ev )=>
      {
        let input = new StorageInput();
        input.id = ElementType.input.query( StorageTest.id.query( e ) ).value;
        input.key = ElementType.input.query( StorageTest.key.query( e ) ).value;
        input.path = ElementType.input.query( StorageTest.path.query( e ) ).value;
        input.requestID = new Date().getTime() + "";

        let getPath = storageURL.path + "get.php";
        console.log( "Get", getPath, input );
        let result = await Request.post<StorageInput,StorageResult>( getPath, input );

        console.log( "Result", result );

        let stringified = JSON.stringify( result.value, null, "  " );
        StorageTest.data.query<HTMLTextAreaElement>( e ).value = stringified;

        console.log( "Result", stringified );
      }
    );

    OnClick.add( listElement, 
      async ( ev )=>
      {
        let input = new StorageInput();
        input.id = ElementType.input.query( StorageTest.id.query( e ) ).value;
        input.key = ElementType.input.query( StorageTest.key.query( e ) ).value;
        input.path = ElementType.input.query( StorageTest.path.query( e ) ).value;
        input.requestID = new Date().getTime() + "";

        let listPath = storageURL.path + "list.php";
        console.log( "Get", listPath, input );
        let result = await Request.post<StorageInput,StorageResult>( listPath, input );

        console.log( "Result", result );

        let stringified = JSON.stringify( result.value, null, "  " );
        StorageTest.data.query<HTMLTextAreaElement>( e ).value = stringified;

        console.log( "Result", stringified );
      }
    );

    OnClick.add( removeElement, 
      async ( ev )=>
      {
        let input = new StorageInput();
        input.id = ElementType.input.query( StorageTest.id.query( e ) ).value;
        input.key = ElementType.input.query( StorageTest.key.query( e ) ).value;
        input.path = ElementType.input.query( StorageTest.path.query( e ) ).value;
        input.requestID = new Date().getTime() + "";

        let removePath = storageURL.path + "remove.php";
        console.log( "Get", removePath, input );
        let result = await Request.post( removePath, input );

        console.log( "Result", result );
      }
    );

    
  }

}